import * as React from 'react';
import {Overlayer} from './Overlayer';

export const Layer = ({children}: {children: React.ReactNode}) => (
  // @ts-expect-error - TS2769 - No overload matches this call.
  <Overlayer open render={() => children} />
);

Layer.displayName = 'Layer';
